import * as Types from "../../../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AddOrganisationBankPermissionMutationVariables = Types.Exact<{
  org_banks_objects: Array<Types.Organisation_Banks_Insert_Input>;
  org_bank_exp_objects: Array<Types.Organisation_Bank_Exposure_Limits_Insert_Input>;
}>;

export type AddOrganisationBankPermissionMutation = {
  __typename?: "mutation_root";
} & {
  insert_organisation_banks?: Types.Maybe<
    { __typename?: "organisation_banks_mutation_response" } & Pick<
      Types.Organisation_Banks_Mutation_Response,
      "affected_rows"
    >
  >;
  insert_organisation_bank_exposure_limits?: Types.Maybe<
    {
      __typename?: "organisation_bank_exposure_limits_mutation_response";
    } & Pick<
      Types.Organisation_Bank_Exposure_Limits_Mutation_Response,
      "affected_rows"
    >
  >;
};

export type RemoveOrganisationBankPermissionMutationVariables = Types.Exact<{
  organisation_id: Types.Scalars["Int"];
  bank_id: Types.Scalars["Int"];
}>;

export type RemoveOrganisationBankPermissionMutation = {
  __typename?: "mutation_root";
} & {
  delete_organisation_banks?: Types.Maybe<
    { __typename?: "organisation_banks_mutation_response" } & Pick<
      Types.Organisation_Banks_Mutation_Response,
      "affected_rows"
    >
  >;
  delete_organisation_bank_exposure_limits?: Types.Maybe<
    {
      __typename?: "organisation_bank_exposure_limits_mutation_response";
    } & Pick<
      Types.Organisation_Bank_Exposure_Limits_Mutation_Response,
      "affected_rows"
    >
  >;
};

export const AddOrganisationBankPermissionDocument = gql`
  mutation AddOrganisationBankPermission(
    $org_banks_objects: [organisation_banks_insert_input!]!
    $org_bank_exp_objects: [organisation_bank_exposure_limits_insert_input!]!
  ) {
    insert_organisation_banks(objects: $org_banks_objects) {
      affected_rows
    }
    insert_organisation_bank_exposure_limits(
      objects: $org_bank_exp_objects
      on_conflict: {
        constraint: organisation_bank_exposure_limits_organisation_id_bank_id_key
        update_columns: [exposure_limit]
      }
    ) {
      affected_rows
    }
  }
`;

export function useAddOrganisationBankPermissionMutation() {
  return Urql.useMutation<
    AddOrganisationBankPermissionMutation,
    AddOrganisationBankPermissionMutationVariables
  >(AddOrganisationBankPermissionDocument);
}
export const RemoveOrganisationBankPermissionDocument = gql`
  mutation RemoveOrganisationBankPermission(
    $organisation_id: Int!
    $bank_id: Int!
  ) {
    delete_organisation_banks(
      where: {
        bank_id: { _eq: $bank_id }
        organisation_id: { _eq: $organisation_id }
      }
    ) {
      affected_rows
    }
    delete_organisation_bank_exposure_limits(
      where: {
        bank_id: { _eq: $bank_id }
        organisation_id: { _eq: $organisation_id }
      }
    ) {
      affected_rows
    }
  }
`;

export function useRemoveOrganisationBankPermissionMutation() {
  return Urql.useMutation<
    RemoveOrganisationBankPermissionMutation,
    RemoveOrganisationBankPermissionMutationVariables
  >(RemoveOrganisationBankPermissionDocument);
}
